var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 24,
    height: 24,
    rx: 12,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8.80066,
    y: 14.1006,
    width: 1.60007,
    height: 1.60007,
    fill: "#6D6D6D"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 7.20001,
    y: 15.7007,
    width: 1.60007,
    height: 1.60007,
    fill: "#6D6D6D"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 1.60007,
    height: 1.60007,
    transform: "matrix(1 0 0 -1 8.80066 10.9004)",
    fill: "#6D6D6D"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 1.60007,
    height: 1.60007,
    transform: "matrix(1 0 0 -1 7.20001 9.30029)",
    fill: "#6D6D6D"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 1.60007,
    height: 1.60007,
    transform: "matrix(1 0 0 -1 10.3994 12.5005)",
    fill: "#6D6D6D"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 1.60007,
    height: 1.60007,
    transform: "matrix(1 0 0 -1 12.0001 14.1006)",
    fill: "#6D6D6D"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 13.6008,
    y: 9.30029,
    width: 1.60007,
    height: 1.60007,
    fill: "#6D6D6D"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 15.2002,
    y: 7.7002,
    width: 1.60007,
    height: 1.60007,
    fill: "#6D6D6D"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 1.60007,
    height: 1.60007,
    transform: "matrix(1 0 0 -1 13.6008 15.7007)",
    fill: "#6D6D6D"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 1.60007,
    height: 1.60007,
    transform: "matrix(1 0 0 -1 15.2002 17.3008)",
    fill: "#6D6D6D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseError);
export default __webpack_public_path__ + "static/media/close-error.a3fe413895256ca1bb87f09e62b9fbe9.svg";
export { ForwardRef as ReactComponent };